// Search 组件的搜索框类型
export const CONDITION_TYPE = {
  TEXT: 'text',
  SELECT: 'select',
  TIME: 'time',
  DATE: 'date',
  DATETIME: 'datetime',
  SELECT_GROUP: 'select_group'
}

// Search 组件的时间显示类型
export const DATE_PICKER_SHOW_TYPE = {
  YEAR: 'year',
  MONTH: 'month',
  DATE: 'date',
  WEEK: 'week',
  DATETIME: 'datetime',
  DATETIME_RANGE: 'datetimerange',
  DATE_RANGE: 'daterange'
}

// 平台列表
export const PLATFORM_LIST = []

// 服务列表
export const SERVICE_LIST = [
  {id: 1, title: '首联反馈', status: 1}
]

// session key
export const SESSION_KEY = {
  USER: 'user',
  PERMS: 'perms'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js